import script from "./EditRiskDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./EditRiskDialog.vue?vue&type=script&lang=ts&setup=true"

import "./EditRiskDialog.vue?vue&type=style&index=0&id=6ca9bb59&lang=scss&scoped=true"
import "./EditRiskDialog.vue?vue&type=style&index=1&id=6ca9bb59&lang=scss"

import exportComponent from "E:\\workspace13\\aries-backend-front\\kailas-aries\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+comp_64f3209c872a893711b3e776f2c9ff1e\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ca9bb59"]])

export default __exports__